import { DistrictsTableDM } from "@/components/districts/districts-table";
import { DistrictsTableReseller } from "@/components/districts/districts-table-reseller";
import { useEffectiveRole } from "@/hooks/use-effective-role";

export function DistrictsPage() {
	const role = useEffectiveRole();

	return (
		<div className="flex min-h-0 flex-1 flex-col gap-4 p-4 lg:p-6">
			{role === "reseller" ? <DistrictsTableReseller /> : <DistrictsTableDM />}
		</div>
	);
}
